export const InfoConfigValues = {
  required: 'required',
  optional: 'optional',
  disabled: 'disabled',
};
